import { useSelector } from 'react-redux'
import { IAppStore } from '../../../../models/store.model'

/**
 * Id del usuario logueado para auditar acciones (quién aprobó/solicitó).
 * Devuelve null si no hay sesión cargada (id 0 cuenta como no logueado).
 */
export const useUserId = (): number | null => {
  const id = useSelector((s: IAppStore) => s.user?.id ?? null)
  return id !== null && id > 0 ? id : null
}
